<template>
  <div class="main-container">
    <div class="bgposition">
        <div v-for="item in bgarr" class="bg_block" :style="{backgroundImage: 'url('+ item.img + ')',height:item.height+'px'}"></div>
    </div>
    <div class="position_relative">
        <div class="_2014_1111_desc1">这个双十一明智购物，理性消费，只为值得下单。小鱼科学测评，解锁心动好物，让你不为冲动买单，只为心动付款！</div>
        <div v-for="(item,index) in productDatas">
            <div class="_2024_1111_box" :class="item.margin_top">
                <div class="_2024_1111_box_title">{{item.title}}</div>
                <div class="_2024_1111_box_content">{{item.desc}}</div>
            </div>
            <div class="categorys_box" v-for="(val,valindex) in item.categorys" >
                <div class="textalign_left">
                    <div class="categorys_title">
                        {{val.title}}
                    </div>
                    <div class="categorys_desc">
                        <div class="_desc"> 
                            {{val.desc}}
                        </div>
                         
                    </div>
                </div>
                <div>
                    <!-- <div class="box_padding" v-for="(val,valindex) in item.categorys" > -->
                        <div v-for="(value,valueindex) in val.products" class="_618_product_box display_flex" @click="toProductDetail(value.type,value.id)" >
                            <div class="_1111_product_box_imgcontain">
                                <div class="_1111_product_box_img">
                                    <img :src="value.img" 
                                class=" center" :class="value.imgclass"></img>
                                    <img src="https://p1.fishqc.net/FooMAleWAOXTrBgw2AHWIIjiDZL4" class="greenfish"></img>
                                </div>
                                
                            </div>
                            <div  class="product_detail_contain display_flex  derection-column justify-content_flex-justify" style="flex:1" :class="{'padding_right_1':value.id == 'm0y5kZo-ICWELyBMy-4TQQ'}">
                                <div>
                                    <div class="brand" :class="{'smallSize':(value.id=='4gzuhzJvhN-mF8qNaKY5Gw')}" v-html="value.brand"></div>
                                    <div class="_1111_product_title" v-html="value.title"></div>
                                </div>
                                
                                <div>
                                    <div class="product_tab">{{value.tips}}</div>
                                    <div class="address" :class="{'padding_top_10':(value.id == 'm0y5kZo-ICWELyBMy-4TQQ'  || value.id == 'pENF2Fy8G-uql2Q_xux6rQ')}">品牌所在地：{{value.address}}</div>
                                </div>
                            </div>
                        </div>
                    <!-- </div>  -->
                </div>
                
            </div>
           
              
        </div>
        <div v-for="value in technoarr">
            <img :src="value.img"  class="tech" :class="value.class"></img>

        </div>

    </div>
  </div>
</template>
<style lang="scss" scoped>
@import "@/assets/css/mixin.scss";
div {
  box-sizing: border-box;
}

.mb-0 {
  margin-bottom: 0!important;
}

.desc {
  width: 880px;
  margin-bottom: 20px;
  text-align: left;
  font-size: 24px;
  font-weight: 800;
  line-height: 36px;
}

.main-container {
  box-sizing: border-box;
  height: 7911px;
  padding-top: 574px;
  margin: 100px auto 0;
  position: relative;
/*  background: url('https://p1.fishqc.net/lqqJK1qpDxhGKNAFM3hH3g77UlFO') center center no-repeat;*/
/*  background-size: auto 100%;*/
  color: #1B5EAD;
}

.bgposition{
    position: absolute;
    left:0;
    top:0px;
    width:100%;
    height: 7911px;
     background-color: #FFF0D9;
}


.bg_block{
    width:100%;
    background-position: center;
    background-repeat: no-repeat;
    background-size: auto 100%;
    background-color: #FFF0D9;
}


.position_relative{
    position: relative;
}

._2014_1111_desc1{
    width: 1078px;
    font-family: SourceHanSansCN;
    font-weight: 400;
    font-size: 34px;
    color: #62A14B;
    line-height: 56px;
    text-align: center;
    font-style: normal;
    text-transform: none;
    margin:0 auto;
}

._618_title1{
    margin:0 auto;
    display: block;
    &.margin_top_46{
        margin-top:46px;
    }
    
    
    &.size1{
        width:378px;
        height:87px;
        margin-bottom: 22px;
    }
    
    &.size2{
        width:394px;
        height:87px;
        margin-top:84px;
        margin-bottom: 30px;
    }
}

._618_block1_desc{
    width: 892px;
    font-family: PingFang SC;
    font-weight: 400;
    font-size: 32px;
    color: #FEFEFE;
    line-height: 56px;
    text-align: center;
    font-style: normal;
    text-transform: none;
    margin:0 auto;
}


._618_block1_box{
    width:989px;
    height:844px;
/*    background:url('https://p1.fishqc.net/FsoQwAGkaQEA2v4VP2wUFBwax5Bf');*/
    background-position: center;
    background-size: contain;
    background-repeat: no-repeat;
    margin:0 auto;

    &.margin_top_70{
        margin-top:70px;
    }
    &.margin_top_104{
        margin-top:104px;
    }

    &.margin_top_86{
        margin-top:86px;
    }
    &.margin_top_88{
        margin-top:88px;
    }
}

._618_block_titleimg{
    width: 285px;
    height: 69px;
    margin-left: 8px;
}

._618_block_text{
    width: 884px;
    font-family: PingFang SC;
    font-weight: 400;
    font-size: 25px;
    color: #191919;
    line-height: 50px;
    text-align: justify;
    font-style: normal;
    text-transform: none;
    margin:0 auto;
    &.padding_1{
        padding-top: 90px;
        padding-bottom:44px;

    }

    &.padding_2{
        padding-top: 78px;
        padding-bottom:34px;
        
    }

    &.padding_3{
        padding-top: 112px;
        padding-bottom:40px;
        
    }

    &.padding_4{
        padding-top: 108px;
        padding-bottom:38px;
        
    }

    &.padding_5{
        padding-top: 112px;
        padding-bottom:38px;
        
    }

}

.box_padding{
/*   padding:0 30px;*/
   box-sizing: border-box;
   display: flex;
    flex-wrap: wrap;
}


.tech{
    display: block;
    margin:0 auto;
}
.techno1{
    width: 1128px;
    height:1610px;
    margin-top:112px;

}
.techno2{
    width:991px;
    height: 1237px;
    margin-top:42px;
    
}
.techno3{
    width: 487px;
    height: 114px;
    margin-top:102px;
    
}

._618_product_box{
    width: 516px;
    height: 270px;
    background: #ffde8f;
    border-radius: 20px 20px 20px 20px;
/*    border: 2px solid #A07EFF;*/
    vertical-align: top;
    padding:0px 0 0px 278px;
    cursor: pointer;
    margin-top:24px;
    margin-right:24px;
    display:inline-block;
    position:relative;
    &:nth-child(even){
        margin-right:0px;
    }

    ._1111_product_box_imgcontain{
        width: 270px;
        height: 100%;
        position: absolute;
        left:0;
        top:0;
        ._1111_product_box_img{
            width:100%;
            height: 100%;
            position: relative;
        }
        .center{
            position: absolute;
            top:50%;
            left:50%;
            transform: translate(-50%,-50%);
        }

        .greenfish{
            width:88px;
            height: 88px;
            position: absolute;
            right:30px;
            bottom:36px;
        }

        ._618_product1{
            width:236px;
            height:236px;
            background: #fff;
            border-radius: 20px;
        }
        ._618_product2{
            width:60px;
            height:178px;
        }
        ._618_product3{
            width:57px;
            height:172px;
        }
        ._618_product4{
            width:58px;
            height:179px;
        }
        ._618_product5{
            width:49px;
            height:192px;
        }
        ._618_product6{
            width:63px;
            height:177px;
        }
        ._618_product7{
            width:118px;
            height:80px;
        }
        ._618_product8{
            width:77px;
            height:165px;
        }
        ._618_product9{
            width:117px;
            height:102px;
        }
        ._618_product10{
            width:101px;
            height:127px;
        }
        ._618_product11{
            width:113px;
            height:87px;
        }
        ._618_product12{
            width:110px;
            height:98px;
        }
        ._618_product13{
            width:131px;
            height:74px;
        }
        ._618_product14{
            width:132px;
            height:92px;
        }
        ._618_product15{
            width:89px;
            height:150px;
        }
        ._618_product16{
            width:104px;
            height:152px;
        }
        ._618_product17{
            width:78px;
            height:153px;
        }
        ._618_product18{
            width:103px;
            height:104px;
        }
        ._618_product19{
            width:81px;
            height:170px;
        }
        ._618_product20{
            width:53px;
            height:186px;
        }

    }
}


.flex_one{
    -webkit-box-flex: 1;
    -ms-flex: 1;
    -webkit-flex: 1;
    flex: 1;    
}

.product_detail_contain{
    height: 100%;
    padding:56px 0 44px;
    box-sizing: border-box;
}

.product_name{
    font-family: PingFang SC;
    font-weight: 500;
    font-size: 22px;
    color: #191919;
    line-height: 33px;
    text-align: left;
    font-style: normal;
    text-transform: none;
}

.product_tab{
    width: 96px;
    height: 30px;
    background: #D8FFB8;
/*    box-shadow: inset 3px 0px 9px 0px #BBA7FF;*/
    border-radius: 16px 0px 16px 0px;
    font-family:  SourceHanSansCN;
    font-weight: 400;
    font-size: 16px;
    color: #3C782B;
    line-height: 30px;
}

.brand{
    font-family: SourceHanSansCN;
    font-weight: 500;
    font-size: 24px;
    color: #CB640C;
    line-height: 30px;
    text-align: left;

    &.padding_top_10{
        padding-top:10px;
    }

    &.smallSize{
        font-size: 22px;
    }
}
.derection-column{
    flex-direction: column;
    -webkit-flex-direction: column;
}

._2024_1111_box{
    width: 1056px;
    height: 253px;
    background: #FFFFFF;
/*    box-shadow: 8px 8px 7px 8px #2264AE;*/
    border-radius: 20px 20px 20px 20px;
    margin:134px auto 0;
    padding:0 34px;
    &.margin_Top_74{
        margin-top:74px;
    }
    &.margin_Top_134{
        margin-top:134px;
    }
}

._2024_1111_box_title{
    width: 443px;
    height: 105px;
    background: #509A3B;
    box-shadow: 0px 8px 8px 8px #2264ae0d;
    border-radius: 0px 0px 50px 50px;
    margin:0 auto;
    
    box-sizing: border-box;
    font-family: HelloFont;
    font-weight: normal;
    font-size: 42px;
    color: #FFFFFF;
    line-height: 105px;
/*    text-shadow: 8px 8px 7px #2264AE;*/
}

._2024_1111_box_content{
    font-family: SourceHanSansCN;
    font-weight: 400;
    font-size: 28px;
    color: #509A3B;
    line-height: 48px;
    text-align: justify;
    font-style: normal;
    text-transform: none;
    padding-top:22px;


}

.categorys_box{
    width: 1056px;
    margin:0 auto;
    padding:30px 0 0;
}
.categorys_title{
    padding:0 36px 0 30px;
    height: 50px;
    line-height: 50px;
    background: #FC9639;
    border-radius: 0px 30px 0px 0px;
    display: inline-block;
    font-family: SourceHanSansCN;
    font-weight: 400;
    font-size: 28px;
    color: #FFFFFE;
    text-align: left;
    font-style: normal;
    text-transform: none;

}

.categorys_desc{
    height: 151px;
    background: #FFFFFF;
    border-radius: 0px 20px 20px 20px;
    
    position: relative;
    width:100%;
    
    
    ._desc{
        width:100%;
        position: absolute;
        top:50%;
        transform: translate(0,-50%);
        font-family: SourceHanSansCN;
        font-weight: 400;
        font-size: 28px;
        color: #509A3B;
        line-height: 48px;
        text-align: justify;
        font-style: normal;
        text-transform: none;
        padding:0 30px;
        box-sizing:border-box;
    }

}

._1111_product_title{
    font-family: SourceHanSansCN;
    font-weight: 400;
    font-size: 18px;
    color: #CB640C;
    line-height: 24px;
    text-align: left;
    padding-top:6px;
}

.address{
    font-family: SourceHanSansCN;
    font-weight: 400;
    font-size: 16px;
    color: #CB640C;
    line-height: 16px;
    text-align: left;
    padding-top:10px;
}
</style>
<script>
import { myMixin } from '@/mixin/mixin.js'
export default {
  // name: '2023-618',
  mixins: [myMixin],
  data() {
    return {
        bgarr:[
            {
                img:'https://p1.fishqc.net/Fk1Z7Y0-DXkiWeIZEeVFJ5V5YgT3',
                height:'1720'
            },
            {
                img:'https://p1.fishqc.net/FqIAmcfL7Jd9MQprzH_GvvqCMce3',
                height:'1783'
            },
            {
                img:'https://p1.fishqc.net/FusTMV9EAOmj2dLBWEuBwzefqSxJ',
                height:'2072'
            },
            {
                img:'https://p1.fishqc.net/FoFR3VJYEyUsqxVKFqdOTzm_GMo9',
                height:'2336'
            }
            
        ],
        productDatas: [
            {
                title: '护肤优品',
                desc:'羊毛人可不能被各种优惠冲昏头脑，必囤的护肤优品，跟着科学测评的绿鱼榜单买。让你在全年省钱日，购物零负担。',
                titleImgClass:'size1',
                margin_top:'margin_Top_134',
                categorys: [{
                        title: '精华',
                        desc: '精华作为护肤界明星产品，不仅浓缩多种功效成分改善肤质，还能提供额外的保湿和滋养，使皮肤更加健康和年轻。',
                        
                     
                       
                        products: [
                            {
                                img: 'https://p1.fishqc.net/FuEAo6wF-BpIXIprMt4kuKJvYdb6',
                                imgclass:'_618_product1',
                                brand: 'PURID朴理 ',
                                title: '创研修护焕然精华液<br>（2号精华）',
                                tips: '抗红修护',
                                address: '中国',
                                type: 'cosmetic',
                                id: 'uBKKOZ0Ao5UKRKyj9CEC6g',
                                
                            },
                            {
                                img: 'https://p1.fishqc.net/Fnq8DUbRTf_FP1WqnlE-kVVF6rXT',
                                imgclass:'_618_product1',
                                brand: 'SKINCEUTICALS<br>修丽可 ',
                                title: '植萃舒缓亮妍精华露',
                                tips: '舒缓褪红',
                                address: '美国',
                                type: 'cosmetic',
                                id: 'DdB7MXBnpsfWJUxHJ23liQ',
                                
                            },
                            {
                                img: 'https://p1.fishqc.net/FrHJkBr7DY_7lW0ijfPfhFPNmDTH',
                                imgclass:'_618_product1',
                                brand: 'HELENA RUBINSTEIN<br>赫莲娜',
                                title: '至盈抚纹精华液',
                                tips: '立体抚纹',
                                address: '法国',
                                type: 'cosmetic',
                                id: '4gzuhzJvhN-mF8qNaKY5Gw',
                                
                            },
                            {
                                img: 'https://p1.fishqc.net/Fj1s2-yWyI7YbTDDn1s8hTHdsltE',
                                imgclass:'_618_product1',
                                brand: "SHISEIDO资生堂  ",
                                title: '红妍肌活精华露',
                                tips: '细腻补水',
                                address: '日本',
                                type: 'cosmetic',
                                id: 'mle-7Lk6Zoc9nmF_WpNDVQ',
                                
                            }
                        ]
                    },
                    {
                        title: '面霜',
                        desc: '秋燥冬寒，肌肤容易有小情绪，面霜相较乳液滋润性更强，安全面霜可以补充及锁住水份，肌肤和心情都更愉悦。',
                        paddingclass:'padding_2',
                        margin_top:'margin_top_104',
                        imgbg:'https://p1.fishqc.net/FtkTpsXWOoyIOJzu0mTKhBE65I3D',
                        height:'840',
                        products: [
                            {
                                img: 'https://p1.fishqc.net/FkB_gzCmNtpK4iadyoO69JL-pvNW',
                                imgclass:'_618_product1',
                                brand: 'LANEIGE兰芝',
                                title: '新水酷特润乳霜',
                                tips: '干皮挚爱',
                                address: '韩国',
                                type: 'cosmetic',
                                id: 'T1dVTV3BlkWeXoSrb3syKw',
                                
                                
                            },
                            {
                                img: 'https://p1.fishqc.net/FmxXB8mVJC-puJUY4qKvmpaFectV',
                                imgclass:'_618_product1',
                                brand: 'MyClorisLand<br>花皙蔻 ',
                                title: '菁纯牡丹抗皱淡纹精华霜',
                                tips: '紧致淡纹',
                                address: '中国',
                                type: 'cosmetic',
                                id: 'li4ioIgu8L4wYXMSzN4LYA',
                                
                            },
                            {
                                img: 'https://p1.fishqc.net/Fqh9lCS_W_EbFOumHWXghnAv-Ol-',
                                imgclass:'_618_product1',
                                brand: 'ESTEE LAUDER<br>雅诗兰黛 ',
                                title: '鲜活亮采晚霜',
                                tips: '丰盈饱满',
                                address: '美国',
                                type: 'cosmetic',
                                id: 'fF3VDWuCzV_T_Sqr70Ki4A',
                                
                            },
                            {
                                img: 'https://p1.fishqc.net/Fhdn96ydvnKosMIV36RrWU98RKaf',
                                imgclass:'_618_product1',
                                brand: 'Clé de Peau Beauté<br>肌肤之钥 ',
                                title: '金致乳霜',
                                tips: '滋养弹润',
                                address: '日本',
                                type: 'cosmetic',
                                id: 'pvSTCcpvKrUdcPkn_4SYnA',
                                
                            }
                        ]
                    },
                    {
                        title: '眼霜',
                        desc: '眼周肌肤角质层薄、易受伤害，容易缺水。选择安全的眼霜产品，让眼周肌肤更加健康柔滑，使双眼明亮有神。',
                        paddingclass:'padding_3',
                        margin_top:'margin_top_86',
                        imgbg:'https://p1.fishqc.net/FrHKbHY5vQVd4RNpAE7C5nESVuN-',
                        height:'844',
                        products: [{
                                img: 'https://p1.fishqc.net/FpzPaQM_6sbeW7kEGbVISb3BE46t',
                                imgclass:'_618_product1',
                                brand: 'OLAY玉兰油 ',
                                title: '多效修护眼霜',
                                titleFont: true,
                                tips: '七大功效',
                                address: '美国',
                                type: 'cosmetic',
                                id: 'rACZYvy0Yr9MeygY3rmLgg',
                                bgSize: 'contain',
                                
                            },
                            {
                                img: 'https://p1.fishqc.net/FsERkGSTOyPQs2m_FD6FqOFBeWDa',
                                imgclass:'_618_product1',
                                brand: 'AVENE雅漾 ',
                                title: '轻柔光彩亮泽眼霜',
                                tips: '舒缓眼周',
                                address: '法国',
                                type: 'cosmetic',
                                id: '04tpKu6eDHShdToy3UR7-A',
                                
                            },
                            {
                                img: 'https://p1.fishqc.net/Fu9UX2deXidyH09hQyxjsQpj5tZy',
                                imgclass:'_618_product1',
                                brand: 'LA ROCHE-POSAY<br>理肤泉 ',
                                title: '特安舒缓眼霜',
                                tips: '滋润保湿',
                                address: '法国',
                                type: 'cosmetic',
                                id: '0Y03-HSoEWcAcYBENRRuvA',
                                
                            },
                            {
                                img: 'https://p1.fishqc.net/FoGm0zwYLWrGdx4cNGpFKFAmtFSI',
                                imgclass:'_618_product1',
                                brand: 'NIVEA妮维雅',
                                title: '细胞激活抗皱紧致修护眼霜',
                                tips: '充盈淡纹',
                                address: '德国',
                                type: 'cosmetic',
                                id: 'OH8JbaEkAONPChleAqkIrA',
                                
                            }
                        ]
                    }
                    
                ]
            },
            {
                title: '美妆好物',
                desc:'省钱时刻可不能忘记平时舍不得下手的美妆好物，双十一也必须全款拿下。科学测评的安全优品让你在省钱的同时更省心。',
                titleImgClass:'size2',
                margin_top:'margin_Top_74',
                categorys: [{
                        title: '润唇膏',
                        desc: '唇周角质层薄弱，无皮脂腺或汗腺等保护水分，涂抹安全的润唇膏，为双唇锁住水分提供屏障，并隔离化妆品的色素。',
                        paddingclass:'padding_4',
                        margin_top:'margin_top_88',
                        imgbg:'https://p1.fishqc.net/FvmJiomfmiC9twGHYHana-HftOuL',
                        height:'845',
                        products: [{
                                img: 'https://p1.fishqc.net/FnKWrtrFUSFcCB38KOuS3wVw_bvM',
                                imgclass:'_618_product1',
                                brand: 'DIOR ADDICT迪奥 ',
                                title: '诱惑焕彩润唇膏<br> (001)',
                                tips: '滋润焕亮',
                                address: '法国',
                                type: 'cosmetic',
                                id: 'frn5f17n2zMs3y5FeCiGJw',
                                
                            },
                            {
                                img: 'https://p1.fishqc.net/FlTpLnfCmbD09S7Avlo3S49evGsc',
                                imgclass:'_618_product1',
                                brand: 'NUXE欧树',
                                title: '蜂蜜润唇膏',
                                tips: '高度保湿',
                                address: '法国',
                                type: 'cosmetic',
                                id: 'xa02RUoDl9aS-sxSMu_ggA',
                                
                            },
                            {
                                img: 'https://p1.fishqc.net/FtCYtBdjyylS3adYW-QfoGtfNkmS',
                                imgclass:'_618_product1',
                                brand: "KIEHL'S科颜氏",
                                title: '护唇膏一号',
                                tips: '淡化唇纹',
                                address: '美国',
                                type: 'cosmetic',
                                id: 'vdHYFq40L3Uiw1RIhLCUBA',
                                
                            },
                            {
                                img: 'https://p1.fishqc.net/FmNFo4GqaS38Vz2RgcxwSkKMtku9',
                                imgclass:'_618_product1',
                                brand: "CLARINS娇韵诗  ",
                                title: '恒润奇肌保湿护唇霜',
                                tips: '充分润泽',
                                address: '法国',
                                type: 'cosmetic',
                                id: 'M4mAg0FmAIKZCQ7yiKgwRg',
                                
                            }
                        ]
                    },
                    {
                        title: '腮红',
                        desc: '红润气色靠腮红，营造不同气质，迷倒你的那个他，但劣质腮红会导致皮肤过敏，认准绿鱼优品，美丽又安心。',
                        paddingclass:'padding_5',
                        margin_top:'margin_top_88',
                        imgbg:'https://p1.fishqc.net/FgCYMyPQ4RBBx-9caFp-qE7FdOEE',
                        height:'842',
                        products: [
                            {
                                img: 'https://p1.fishqc.net/Ft2_PRGOfSdEYj9uMUKP8mZ9cACW',
                                imgclass:'_618_product1',
                                brand: 'MAQUILLAGE<br>心机彩妆 ',
                                title: '星魅腮红 (PK200)',
                                tips: '红润气色',
                                address: '日本',
                                type: 'cosmetic',
                                id: 'MFd41MJhOh9O2s7alN4uJA',
                                
                                
                            },
                            {
                                img: 'https://p1.fishqc.net/FhSCoae306IZVo3w788TMCH-Bwck',
                                imgclass:'_618_product1',
                                brand: 'MUJI无印良品 ',
                                title: '腮红哑光型桃红色 <br>(A47)',
                                tips: '自然贴肤',
                                address: '日本',
                                type: 'cosmetic',
                                id: 't-X4FME8gczg8TXpD-CXCQ',
                                
                            }
                        ]
                    },
                    {
                        title: '卸妆',
                        desc: '彩妆残留堵塞毛孔，容易伤害皮肤，选择干净有效且安全温和的卸妆产品，才是对自己面部肌肤最好的呵护。',
                        paddingclass:'padding_5',
                        margin_top:'margin_top_88',
                        imgbg:'https://p1.fishqc.net/FgCYMyPQ4RBBx-9caFp-qE7FdOEE',
                        height:'842',
                        products: [
                            {
                                img: 'https://p1.fishqc.net/FhKVyCrmfHD8oSPBuZVbv-oUBIr-',
                                imgclass:'_618_product1',
                                brand: 'SHU UEMURA<br>植村秀 ',
                                title: '绿茶新肌洁颜油',
                                tips: '一步卸净',
                                address: '日本',
                                type: 'cosmetic',
                                id: 'MZzspQXH1NxoM6Qyx2i9Ug',
                                
                                
                            },
                           
                            {
                                img: 'https://p1.fishqc.net/FtEX0TCcFwedQT7ctpFlrH4oOM_5',
                                imgclass:'_618_product1',
                                brand: 'FANCL芳珂 ',
                                title: '速净卸妆油',
                                tips: '温和清除',
                                address: '日本',
                                type: 'cosmetic',
                                id: 'DxANjzmlnE_68OfBAzWJkw',
                                
                            },
                            
                        ]
                    }
                    
                    
                ]
            },
            
        ],
        technoarr:[
            {
                img:'https://p1.fishqc.net/FvA79k5S-Vm8KpJviA9ap5AN0Gbi',
                class:'techno1'
            },
            
        ]
                
    }

  },
  computed: {
    swiper() {
      return this.$refs.order_report_Swiper.$swiper
    }
  },
  mounted() {
    // var position  =  this.$route.query.position
    // this.scrollTo(position)
    this.currentlang = window.localStorage.getItem("LOCALE") || 'chs'
  },
  methods: {
    scrollTo(position) {
      var that = this;
      var scroll_H;
      this.$nextTick(function () {
        if (position == 'greenrank') {
          var d = document.getElementById("greenrank");
          var topPos = d.offsetTop;
          scroll_H = topPos - 110; //减去header高度
        } else {
          scroll_H = this.$refs[position].offsetTop - 110; //减去header高度
        }
        //全局方法
        that.scrollToY(scroll_H, 1500, 'easeInOutQuint');
      })
    },
    toProductDetail(type, prdid) {
      this.$router.push({
        path: '/product/' + type + '/' + prdid
      })

    }
  }
}
</script>